import { useState } from 'react';

import { CheckCircledIcon, CopyIcon } from '@radix-ui/react-icons';
import { IconButton, Tooltip } from '@raystack/apsara';

import { Show } from '@src/hoc';

export const copyTextToClipboard = async (text, setSuccess = () => {}) => {
  try {
    await navigator.clipboard.writeText(text);
    setSuccess(true);
    setTimeout(() => {
      setSuccess(false);
    }, 800);
  } catch (err) {
    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;

      // Ensure it's not displayed
      textarea.style.position = 'fixed';
      textarea.style.opacity = 0;

      document.body.appendChild(textarea);

      textarea.select();
      document.execCommand('copy');

      document.body.removeChild(textarea);
      setSuccess(true);

      setTimeout(() => {
        setSuccess(false);
      }, 800);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  }
};

export default function CopyText({ text }) {
  const [success, setSuccess] = useState(false);

  return (
    <Show when={!success} fallback={<CheckCircledIcon />}>
      <Tooltip message='Copy text' side='top' contentStyle={{ zIndex: 10000 }}>
        <IconButton
          size={3}
          onClick={() => copyTextToClipboard(text, setSuccess)}
          data-test-id={`copy-icon-${text}`}
        >
          <CopyIcon />
        </IconButton>
      </Tooltip>
    </Show>
  );
}
